import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["sx"];
import React, { memo } from 'react';
import Chip from "@mui/material/Chip/Chip.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var TitleChip = function TitleChip(_ref) {
  var sx = _ref.sx,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Chip, _extends({}, props, {
    sx: [{
      marginLeft: 1
    }].concat(_toConsumableArray(Array.isArray(sx) ? sx : [sx]))
  }));
};
TitleChip.defaultProps = {
  shape: 'square',
  size: 'small',
  color: 'secondary'
};
export default /*#__PURE__*/memo(TitleChip);